export default __webpack_public_path__ + "static/media/iota.5b0b881d.svg";